import type { TourDefinition } from '../types'

// Runs on the Clusters list page (Infrastructure → Clusters), where every step
// has a real target. Steps 3–4 point at the first live cluster card, so they are
// `optional`: with no clusters yet, the tour is just the first two steps.
// Health and engine settings live on each cluster's own page, so the copy
// points there instead of highlighting something this page doesn't show.
export const clustersTour: TourDefinition = {
  id: 'clusters',
  title: 'Clusters Tour',
  description: 'Learn how to connect and manage your BYOK Kubernetes clusters.',
  icon: 'Server',
  roles: ['tenant_owner', 'tenant_admin'],
  route: '/tenant/infra/clusters',
  estimatedMinutes: 3,
  steps: [
    {
      element: '[data-tour-id="clusters-list"]',
      popover: {
        title: 'Your BYOK Clusters',
        description:
          'Every Kubernetes cluster you connect appears here as a card showing its status, engines and details.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'What is a BYOK cluster and how does Vharta connect to my Kubernetes cluster?',
    },
    {
      element: '[data-tour-id="connect-cluster-btn"]',
      popover: {
        title: 'Add a Cluster',
        description: 'Connect any Kubernetes cluster—on-prem, AKS, EKS, GKE—to run your engines.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'What do I need to connect a new Kubernetes cluster to Vharta?',
    },
    {
      element: '[data-tour-id="cluster-status"]',
      optional: true,
      popover: {
        title: 'Cluster Status',
        description:
          "Each card shows its cluster's status: Active when it's connected and running normally; Degraded, Agent Offline or Failed when it needs attention. Open a cluster to see its live health.",
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'What do the cluster statuses mean, and how do I fix a cluster that is degraded or offline?',
    },
    {
      element: '[data-tour-id="cluster-engines"]',
      optional: true,
      popover: {
        title: 'Engines',
        description:
          "The workflow engines this cluster runs. Open the cluster's Settings to add, remove or tune its engines; each engine's credentials are managed on the Credentials tab.",
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext:
        'How do I add or remove engines on a connected cluster, and how are their credentials stored and rotated?',
    },
  ],
}
